/**
 * Ссылка «Генерировать» из выделения референсов: `/generate?ref=…&ref=…`.
 *
 * Порядок — как на экране (`shown`: на уровне папок — обложки, потом россыпь), выделенные
 * вне экрана (другие папки, другой фильтр) — следом в порядке данных (`all`). Модуль без
 * импортов: его напрямую грузит `node --test`.
 */
export function generateHref(
  selected: ReadonlySet<number>,
  shown: readonly { id: number }[],
  all: readonly { id: number }[],
): string {
  const ids: number[] = [];
  for (const { id } of [...shown, ...all]) if (selected.has(id) && !ids.includes(id)) ids.push(id);
  const q = new URLSearchParams();
  for (const id of ids) q.append("ref", String(id));
  const s = q.toString();
  return s ? `/generate?${s}` : "/generate";
}
